import { render, staticRenderFns } from "./bus.vue?vue&type=template&id=312e281c&scoped=true"
import script from "./bus.vue?vue&type=script&lang=js"
export * from "./bus.vue?vue&type=script&lang=js"
import style0 from "./bus.vue?vue&type=style&index=0&id=312e281c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312e281c",
  null
  
)

export default component.exports